/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import {
  Container,
  DropdownMenu,
  CountryInput,
  Button,
  HeadingText,
  CopyToClipboardIcon,
  CheckmarkBackgroundSmIcon,
} from '@paypalcorp/pp-react'
import {
  sbCountries,
  cardOptions,
} from '../../../utils/creditcardgenerator/ccgdata'
import { creditCardGenerator } from '../../../utils/creditcardgenerator/ccghelper'
import { copyToClipboard } from '../../../utils'
import './creditcardgenerator.css'

const copyDataType = {
  card_number: { copied: false },
  expiry_date: { copied: false },
  cvv2: { copied: false },
}

function CreditCardGenerator() {
  const [selectedCC, setSelectedCC] = useState('Visa')
  const [selectedCountry, setSelectedCountry] = useState('US')
  const [generatedCard, setGeneratedCard] = useState()
  const [error, setError] = useState()
  const [isCopied, setIsCopied] = useState(false)
  const [copiedDataStatus, updateCopiedDataStatus] = useState(copyDataType)

  const generateCard = () => {
    setError(null)
    const generatedCreditCard = creditCardGenerator(selectedCC, selectedCountry)

    if (generatedCreditCard.message) {
      setError(generatedCreditCard)
    } else {
      setGeneratedCard(generatedCreditCard)
    }
  }

  const copyData = (data, type) => {
    copyToClipboard(data)
    setIsCopied(true)
    updateCopiedDataStatus((prev) => ({ ...prev, [type]: { copied: true } }))

    setTimeout(() => {
      setIsCopied(false)
      updateCopiedDataStatus(copyDataType)
    }, 3000)
  }

  useEffect(() => {
    generateCard()
  }, [])

  return (
    <Container className="ccg-container" fluid={true}>
      <div>
        <div>
          <HeadingText size="title" style={{ marginBottom: '1rem' }}>
            Input
          </HeadingText>
          <div style={{ width: '21.875rem' }}>
            <DropdownMenu
              id="simple"
              autoComplete="off"
              label="Card Type"
              options={cardOptions}
              value={selectedCC}
              onChange={(e) => {
                setSelectedCC(e.target.value)
              }}
            />
            <br />
            <CountryInput
              countryList={sbCountries}
              name="country-input"
              value={selectedCountry}
              isLoadingOptions={sbCountries?.length === 0}
              onChange={(e) => setSelectedCountry(e.target.value)}
              theme="v2"
            />
            <br />
            <Button onClick={generateCard} size="lg" className="ccg-button">
              Generate Credit Card
            </Button>
          </div>
        </div>
        <div className="generate-cc-details">
          <HeadingText size="title" style={{ marginBottom: '1rem' }}>
            Generated credit card details
          </HeadingText>
          {error && (
            <div>
              <div>
                <span data-error>Error: </span>
                <span>{error?.message}</span>
              </div>
            </div>
          )}
          {generatedCard && (
            <div className="ccg-details">
              <div>
                <span>Card number</span>
                <span>
                  <span>{generatedCard?.card_number}</span>
                  {copiedDataStatus?.card_number?.copied && isCopied ? (
                    <CheckmarkBackgroundSmIcon
                      size="sm"
                      color="sysColorAccent3Main"
                    />
                  ) : (
                    <CopyToClipboardIcon
                      size="sm"
                      onClick={() =>
                        copyData(generatedCard?.card_number, 'card_number')
                      }
                    />
                  )}
                </span>
              </div>
              <div>
                <span>Expiry date</span>
                <span>
                  <span>
                    {generatedCard?.expiry_month}/{generatedCard?.expiry_year}
                  </span>
                  {copiedDataStatus?.expiry_date?.copied && isCopied ? (
                    <CheckmarkBackgroundSmIcon
                      size="sm"
                      color="sysColorAccent3Main"
                    />
                  ) : (
                    <CopyToClipboardIcon
                      size="sm"
                      onClick={() =>
                        copyData(
                          `${generatedCard?.expiry_month}/${generatedCard?.expiry_year}`,
                          'expiry_date',
                        )
                      }
                    />
                  )}
                </span>
              </div>
              <div>
                <span>CVC code</span>
                <span>
                  <span>{generatedCard?.cvv2}</span>
                  {copiedDataStatus?.cvv2?.copied && isCopied ? (
                    <CheckmarkBackgroundSmIcon
                      size="sm"
                      color="sysColorAccent3Main"
                    />
                  ) : (
                    <CopyToClipboardIcon
                      size="sm"
                      onClick={() => copyData(generatedCard?.cvv2, 'cvv2')}
                    />
                  )}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </Container>
  )
}

export default CreditCardGenerator
